import Shape from './Shape';
import Coords from '../Util/Coords';
import { Translate } from '../../../i18n/i18n';

export default class SignalMeasure extends Shape {

    constructor(point, color) {
        super();
        this.id = (new Date()).getTime() + '' + (Math.random() * 89999 + 10000)
        this.points = [point, point];
        this.middlePoint = point;
        this.color = color;
        this.distance = 0;
        this.distanceScale = 0;
    }

    export() {
        return {
            id: this.id,
            points: this.points,
            color: this.color
        }
    }

    getId() {
        return this.id;
    }

    setId(id) {
        this.id = id;
    }

    updateProp(key, value) {
        if (key === 'points') {
            this.points = value;
            this.calculateMiddlePoint();
        } else if (key === 'point2') {
            this.points[1] = value;
            this.calculateMiddlePoint();
        }
    }

    calculateDistance(mode = 'square', type = 'precise', scale=1.5, unit='m') {
        let p1 = this.points[0];
        let p2 = this.points[1];

        
        if (mode === 'hexagon') {
            let q = Math.abs(p2[0]-p1[0]);
            let r = Math.abs(p2[1]-p1[1]);
            let s = Math.abs(-p2[1]-p2[0]+p1[1]+p1[0]);
            this.distance = (q+r+s)/2;
        } else {
            let x = Math.abs(p2[0]-p1[0]);
            let y = Math.abs(p2[1]-p1[1]);

            switch (type) {
                case 'diamond':
                    this.distance = x+y;
                    break;
                case 'square':
                    this.distance = x>y ? x : y;
                    break;
                default:
                    this.distance = Math.sqrt(x*x + y*y);
            }
        }

        let atScale = parseFloat(this.distance) * parseFloat(scale);
        this.distance = String(+parseFloat(this.distance).toFixed(2)) + Translate('gridtools.scenerygridsquarename');
        this.distanceScale = String(+parseFloat(atScale).toFixed(2)) + unit;
    }

    calculateMiddlePoint() {
        let p1 = this.points[0];
        let p2 = this.points[1];

        let x = (p2[0]+p1[0])/2;
        let y = (p2[1]+p1[1])/2;

        this.middlePoint = [x,y];
    }

    draw(props) {
        let p1 = Coords.toView(this.points[0], props.viewCenter, props.lookingAt, props.tileSize);
        let p2 = Coords.toView(this.points[1], props.viewCenter, props.lookingAt, props.tileSize);
        let c = Coords.toView(this.middlePoint, props.viewCenter, props.lookingAt, props.tileSize);

        this.ctx.beginPath();
        this.ctx.moveTo(p1[0], p1[1]);
        this.ctx.lineTo(p2[0], p2[1]);

        this.ctx.strokeStyle = this.color;
        this.ctx.fillStyle = "white";
        this.ctx.lineWidth = 3;
        this.ctx.stroke();
        this.ctx.fill();

        
        this.ctx.fillStyle = '#000';
        this.ctx.strokeStyle = '#fff';
        this.ctx.lineWidth = 1;
        this.ctx.font = 'bolder 14px sans-serif';
        this.ctx.textAlign = "center";

        const width1 = this.ctx.measureText(this.distance).width;
        const width2 = this.ctx.measureText(this.distanceScale).width;
        const width = Math.max(width1, width2);

        this.ctx.strokeRect(c[0]-width/2-6, c[1]-22, width+12, 44);
        this.ctx.fillRect(c[0]-width/2-6, c[1]-22, width+12, 44);

        
        this.ctx.fillStyle = '#fff';
        this.ctx.beginPath();
        this.ctx.fillText(this.distance, c[0], c[1]+12);
        this.ctx.fillText(this.distanceScale, c[0], c[1]-3);
        
    }

}